export default __webpack_public_path__ + "static/media/9-10_icon.cd4ebfe8.svg";